var _circle, _circle2, _circle3, _circle4, _path, _circle5, _path2, _circle6, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxTimeline3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 162,
    viewBox: "0 0 16 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 76.5,
    r: 7.5,
    fill: "#1a2b5f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.125,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.875,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15V71",
    stroke: "#1a2b5f"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#1a2b5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H4.5C4.35834 8 4.23967 7.952 4.144 7.856C4.04834 7.76 4.00034 7.64134 4 7.5C3.99967 7.35867 4.04767 7.24 4.144 7.144C4.24034 7.048 4.359 7 4.5 7H7V4.5C7 4.35834 7.048 4.23967 7.144 4.144C7.24 4.04834 7.35867 4.00034 7.5 4C7.64134 3.99967 7.76017 4.04767 7.8565 4.144C7.95284 4.24034 8.00067 4.359 8 4.5V7H10.5C10.6417 7 10.7605 7.048 10.8565 7.144C10.9525 7.24 11.0003 7.35867 11 7.5C10.9997 7.64134 10.9517 7.76017 10.856 7.8565C10.7603 7.95284 10.6417 8.00067 10.5 8H8V10.5C8 10.6417 7.952 10.7605 7.856 10.8565C7.76 10.9525 7.64134 11.0003 7.5 11C7.35867 10.9997 7.24 10.9517 7.144 10.856C7.048 10.7603 7 10.6417 7 10.5V8Z",
    fill: "#ffffff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 154.5,
    r: 7.5,
    fill: "#1a2b5f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8242 152.004C12.9368 152.117 13 152.269 13 152.429C13 152.588 12.9368 152.74 12.8242 152.853L8.32458 157.353C8.26512 157.412 8.19452 157.459 8.11682 157.491C8.03912 157.524 7.95584 157.54 7.87174 157.54C7.78763 157.54 7.70435 157.524 7.62665 157.491C7.54895 157.459 7.47835 157.412 7.41889 157.353L5.18327 155.117C5.12594 155.062 5.0802 154.996 5.04874 154.923C5.01728 154.849 5.00072 154.771 5.00002 154.691C4.99933 154.611 5.01452 154.532 5.0447 154.458C5.07489 154.384 5.11947 154.317 5.17583 154.261C5.2322 154.205 5.29923 154.16 5.373 154.13C5.44678 154.1 5.52583 154.085 5.60554 154.085C5.68525 154.086 5.76403 154.103 5.83727 154.134C5.91051 154.165 5.97676 154.211 6.03213 154.269L7.87154 156.108L11.975 152.004C12.0307 151.948 12.0969 151.904 12.1698 151.874C12.2426 151.844 12.3207 151.828 12.3996 151.828C12.4785 151.828 12.5566 151.844 12.6294 151.874C12.7023 151.904 12.7685 151.948 12.8242 152.004Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84V147",
    stroke: "#1a2b5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTimeline3);
export default __webpack_public_path__ + "static/media/tx-timeline3.a52e790ff9c24ceba31a76e83cf2a8db.svg";
export { ForwardRef as ReactComponent };